// 中文语言包
export default {
  common: {
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    enter: '{field}不能为空',
    success: '操作成功',
    error: '操作失败',
    loading: '加载中...',
    confirm: '确认',
    close: '关闭',
    back: '返回'
  },
  settings: {
    basic: '基本设置',
    siteName: '站点名称',
    siteDescription: '站点描述',
    timezone: '时区',
    language: '语言',
    notification: '通知设置',
    emailServer: '邮箱服务器',
    emailPort: '邮箱端口',
    emailFrom: '发件人邮箱',
    emailPassword: '邮箱密码',
    smtpSecure: 'SMTP安全连接',
    testNotification: '测试通知',
    monitor: '监控设置',
    monitorInterval: '监控间隔',
    timeout: '超时时间',
    alertCooldown: '告警冷却时间',
    maxRetries: '最大重试次数',
    security: '安全设置',
    loginAttempts: '登录尝试次数',
    lockoutDuration: '锁定时长',
    saveSuccess: '保存成功',
    testSuccess: '测试成功'
  },
  dashboard: {
    title: '仪表盘',
    overview: '概览',
    activeAlerts: '活跃告警',
    totalTargets: '总监控目标',
    uptime: '正常运行时间',
    responseTime: '响应时间',
    status: '状态',
    online: '在线',
    offline: '离线',
    warning: '警告'
  },
  'alert-history': {
    title: '告警历史',
    level: '级别',
    target: '监控目标',
    message: '告警信息',
    time: '时间',
    status: '状态',
    resolved: '已解决',
    pending: '待处理'
  },
  'alert-rules': {
    title: '告警规则',
    name: '规则名称',
    condition: '条件',
    threshold: '阈值',
    duration: '持续时间',
    actions: '操作'
  },
  targets: {
    title: '监控目标',
    name: '目标名称',
    url: 'URL',
    interval: '监控间隔',
    timeout: '超时时间',
    status: '状态'
  },
  notifications: {
    title: '通知中心',
    type: '类型',
    content: '内容',
    time: '时间',
    read: '已读',
    unread: '未读'
  },
  login: {
    title: '登录',
    username: '用户名',
    password: '密码',
    remember: '记住我',
    submit: '登录',
    forgot: '忘记密码?',
    register: '注册'
  }
}